import Vue from "vue";
import Vuex from "vuex";
import * as widget from "./modules/widget.js";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    widget
  },
  state: {},
  mutations: {},
  actions: {}
});
